<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    message: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<template>
  <transition name="fade">
    <div class="container has-text-centered empty-state">
      <div class="empty-state">
        <h2 v-if="title" class="title is-3 has-text-tertiary">
          {{ title }}
        </h2>
        <h3 v-if="message" class="subtitle is-5 has-text-tertiary">
          {{ message }}
        </h3>
      </div>
    </div>
  </transition>
</template>

<style lang="sass" scoped>
.empty-state
  opacity: 1
  margin: 50px auto

.fade-enter-active
  transition: opacity .5s 1s

.fade-enter, .fade-leave-to
  opacity: 0
</style>
